module.exports = __webpack_public_path__ + "img/hero_eth.9059baa1.svg";